var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.325 0c.763 0 1.47.398 1.868 1.054l6.166 10.293a2.182 2.182 0 0 1-1.874 3.273H2.157a2.182 2.182 0 0 1-1.86-3.283L6.46 1.05A2.182 2.182 0 0 1 8.325 0zm0 1.455a.726.726 0 0 0-.62.346L1.551 12.075a.727.727 0 0 0 .614 1.09h12.312a.727.727 0 0 0 .628-1.08L8.947 1.805a.727.727 0 0 0-.622-.35zm.007 8.802a.727.727 0 0 1 .1 1.447l-.1.007a.727.727 0 0 1-.106-1.448l.106-.006zm-.007-5.819c.368 0 .673.274.72.629l.007.099v2.909a.727.727 0 0 1-1.448.098l-.006-.098v-2.91c0-.401.325-.727.727-.727z",
    fill: "#FF4550",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlert);
export default __webpack_public_path__ + "static/media/ico-alert.08f8dffa69b48617de36365eb5063962.svg";
export { ForwardRef as ReactComponent };